module.exports = __webpack_public_path__ + "static/media/limpieza-&-spa.da6654be.png";